import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  totalTimeAttendanceOffSiteGrants: null,
  timeAttendanceOffSiteGrants: [],
}

export const mutations = {
  SET_TOTAL_TIME_ATTENDANCE_OFF_SITE_GRANTS(
    state,
    totalTimeAttendanceOffSiteGrants
  ) {
    state.totalTimeAttendanceOffSiteGrants = totalTimeAttendanceOffSiteGrants
  },
  SET_TIME_ATTENDANCE_OFF_SITE_GRANTS(state, timeAttendanceOffSiteGrants) {
    state.timeAttendanceOffSiteGrants = timeAttendanceOffSiteGrants
  },
  ADD_TIME_ATTENDANCE_OFF_SITE_GRANT(state, timeAttendanceOffSiteGrant) {
    state.timeAttendanceOffSiteGrants.push(timeAttendanceOffSiteGrant)
  },
  EDIT_TIME_ATTENDANCE_OFF_SITE_GRANT(state, timeAttendanceOffSiteGrant) {
    const index = state.timeAttendanceOffSiteGrants.findIndex(
      (el) =>
        el.time_attendance_offsite_grant_uuid ===
        timeAttendanceOffSiteGrant.time_attendance_offsite_grant_uuid
    )
    if (index !== -1) {
      state.timeAttendanceOffSiteGrants.splice(
        index,
        1,
        timeAttendanceOffSiteGrant
      )
    }
  },
  DELETE_TIME_ATTENDANCE_OFF_SITE_GRANT(state, timeAttendanceOffSiteGrantUUID) {
    const index = state.timeAttendanceOffSiteGrants.findIndex(
      (el) =>
        el.time_attendance_offsite_grant_uuid === timeAttendanceOffSiteGrantUUID
    )
    if (index !== -1) state.timeAttendanceOffSiteGrants.splice(index, 1)
  },
}

export const actions = {
  fetchTimeAttendanceOffSiteGrants({ commit }, payload) {
    return ApiService.fetchTimeAttendanceOffSiteGrants(payload)
      .then((res) => {
        const timeAttendanceOffSiteGrants = res.data.data
        commit(
          'SET_TIME_ATTENDANCE_OFF_SITE_GRANTS',
          timeAttendanceOffSiteGrants
        )
        commit('SET_TOTAL_TIME_ATTENDANCE_OFF_SITE_GRANTS', res.data.total)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchTimeAttendanceOffSiteGrant({ commit }, payload) {
    return ApiService.fetchTimeAttendanceOffSiteGrant(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  addTimeAttendanceOffSiteGrant({ commit }, payload) {
    return ApiService.addTimeAttendanceOffSiteGrant(payload)
      .then((res) => {
        const timeAttendanceOffSiteGrant = res.data
        commit('ADD_TIME_ATTENDANCE_OFF_SITE_GRANT', timeAttendanceOffSiteGrant)
        return timeAttendanceOffSiteGrant
      })
      .catch((error) => {
        throw error
      })
  },
  editTimeAttendanceOffSiteGrant({ commit }, payload) {
    return ApiService.editTimeAttendanceOffSiteGrant(payload)
      .then((res) => {
        const timeAttendanceOffSiteGrant = res.data
        commit(
          'EDIT_TIME_ATTENDANCE_OFF_SITE_GRANT',
          timeAttendanceOffSiteGrant
        )
        return timeAttendanceOffSiteGrant
      })
      .catch((error) => {
        throw error
      })
  },
  deleteTimeAttendanceOffSiteGrant({ commit }, payload) {
    return ApiService.deleteTimeAttendanceOffSiteGrant(payload)
      .then(() => {
        commit(
          'DELETE_TIME_ATTENDANCE_OFF_SITE_GRANT',
          payload.time_attendance_offsite_grant_uuid
        )
      })
      .catch((error) => {
        throw error
      })
  },
}
